<template>
  <teleport v-if="widget" to="#crentCarfilter">
    <div
      class="orm-py-56 orm-py-sm-70 orm-container-fluid orm-background__image"
      v-if="clientdata"
      :style="{
        backgroundImage: 'url(' + backgroundImage + ')',
      }"
    >
      <div class="orm-container orm-flex_searchbar">
        <div class="orm-row center-xs">
          <div class="orm-col-xs-12 text-center">
            <h1 class="orm-searchbar__title orm-headline__h1 orm-pb-sm-128">
              <span v-if="clientdata['carsearchfilter_title']">
                {{ clientdata["carsearchfilter_title"] }}
              </span>
              <span v-else>{{ i18n("modules/carsearchfilter/title") }}</span>
            </h1>
          </div>
        </div>
        <div class="orm-row orm-carsearchfilter orm-flex_types">
          <div class="orm-carsearchfilter__types">
            <div class="orm-carsearchfilter__typescontainer orm-flex">
              <div
                class="orm-carsearchfilter__typesitem"
                v-for="type in grouptypes"
                :key="type"
                :class="selectedCarType === type ? 'active' : ''"
                @click="setCarType(type)"
              >
                <i class="fas orm-mr-8" :class="getIcon(type)"></i> {{ type }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="orm-carsearchfilter orm-carsearchfilter_row orm-carsearchfilter_row--rounded orm-flex-carsearchfilter_container"
          v-if="ormload"
        >
          <div
            class="orm-carsearchfilter orm-carsearchfilterrow orm-relative"
            v-if="step == 1"
          >
            <div class="orm-flex_modell">
              <div class="orm-flex_modell_inner">
                <div class="orm-relative">
                  <FormSelectCar
                    my-id="CarSelect"
                    :my-label="i18n('search/label/carselect_title') || 'Modell'"
                    :my-options="carGroup"
                    :selected-car-type="selectedCarType"
                    @carSelected="selectCar"
                  />
                </div>
                <div
                  class="orm-carsearchfilter orm-carsearchrow"
                  v-if="abolength.length > 0 && step == 1"
                >
                  <div class="orm-flex_modell">
                    <div class="orm-flex_modell_inner">
                      <div class="orm-relative">
                        <div class="orm-searchbar__headline">
                          <strong>{{
                            i18n("search/label/minabo_title_selected") ||
                              "Abo-Länge Auswählen"
                          }}</strong>
                        </div>
                        <div
                          class="orm-input__control orm-minabo_container--red"
                        >
                          <SimpleSelect
                            :my-options="abolength"
                            :selected="selectedAbo"
                            :backgroundRed="true"
                            @selected="selectAbo"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="orm-flex_date">
              <div class="orm-flex_date_inner">
                <Datepicker
                  :start-only="true"
                  :infobar="false"
                  viewType="mapModule"
                />
              </div>
            </div>
            <div class="orm-flex_plz orm-zipcode-input" v-if="!ownercode">
              <div class="orm-flex_plz_inner">
                <form-input
                  my-id="zipcode"
                  myType="text"
                  myPattern="[0-9]*[.|,]{0,}[0-9]{1,2}"
                  :my-label="i18n('search/label/zipcode') || 'PLZ'"
                  isRequired
                  :myPlaceholder="
                    i18n('search/label/zip_placeholder') || 'Ihre Postleitzahl'
                  "
                  v-model="plz"
                ></form-input>
              </div>
            </div>
            <div class="orm-flex_btn">
              <div class="orm-flex_btn_inner">
                <div class="orm-searchbar__headline">
                  <strong>&nbsp;</strong>
                </div>
                <button
                  class="orm-btn orm-btn--large"
                  :class="[!loading ? '' : 'disable']"
                  @click="getStations()"
                  v-if="carSelected && (plz.length >= 5 || ownercode)"
                >
                  {{ i18n("general/showOffers") }}
                </button>
                <button v-else class="orm-btn orm-btn--large orm-btn--disabled">
                  {{ i18n("general/showOffers") }}
                </button>
              </div>
            </div>
          </div>

          <div
            class="orm-carsearchfilter orm-carsearchfilterrow orm-relative"
            v-if="step == 2"
          >
            <div class="orm-flex_dealer">
              <div class="orm-flex_dealer_inner">
                <div class="orm-searchbar__headline">
                  <strong>{{
                    i18n("search/label/dealer_title") || "Händler"
                  }}</strong>
                </div>
                <Stationpicker
                  :data="stations"
                  type="start"
                  v-model:selectedstation="selectedStation"
                />
              </div>
            </div>

            <div class="orm-flex_btn orm-flex-btn_mwidth">
              <div class="orm-flex_btn_inner">
                <div class="orm-searchbar__headline">
                  <strong>&nbsp;</strong>
                </div>
                <button
                  class="orm-btn orm-btn--large"
                  :class="[!loading ? '' : 'disable']"
                  @click="getCars('/reservation/step1')"
                  v-if="store.getters['userSession/GET_STATION']"
                >
                  {{ i18n("general/showOffers") }}
                </button>
                <button v-else class="orm-btn orm-btn--large orm-btn--disabled">
                  {{ i18n("general/showOffers") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import { defineComponent } from "vue";
import store from "@/store";

import Datepicker from "@/components/ui/datepicker-startonly.vue"; // @ is an alias to /src
import Stationpicker from "@/components/ui/stationpicker-plz.vue"; // @ is an alias to /src
import FormInput from "@/components/ui/INPUTS/FormInputPLZ.vue"; // @ is an alias to /src
import FormSelectCar from "@/components/ui/INPUTS/FormSelectCar.vue"; // @ is an alias to /src
import SimpleSelect from "@/components/ui/INPUTS/SimpleSelect.vue"; // @ is an alias to /src
import { buildDataLayer } from "@/constants/analytics";

// import routes from "@/router/index";

import i18n from "@/mixins/mixins";

export default defineComponent({
  name: "CarFilterPLZ",
  components: {
    Datepicker,
    Stationpicker,
    FormInput,
    FormSelectCar,
    SimpleSelect,
  },
  mixins: [i18n],
  setup() {
    let widget = false;
    const myEle = document.getElementById("crentCarfilter");
    if (myEle !== null) {
      widget = true;
    }

    return {
      widget,
      store,
    };
  },
  props: {
    origin: {
      type: String,
      default: "home",
      required: false,
    },
    ownercode: { required: false },
  },
  data() {
    return {
      station: Object,
      loading: false,
      ormload: false,
      clientdata: null,
      backgroundImage: "",
      stations: {},
      groupFilter: [],
      carGroup: [],
      carcategory: [],
      selectedGroup: [],
      equipment: [],
      selectedCarType: "PKW",
      selectedStation: null,
      plz: "",
      step: 1,
      carSelected: null,
      abolength: [],
      selectedAbo: null,
      grouptypes: [],
    };
  },
  async mounted() {
    this.ormload = await store.getters["general/GET_ORMLOADED"];
    this.clientdata = await store.getters["general/GET_CLIENT_DATA"];
    this.stations = await store.getters["stations/GET_STATIONS"];
    this.station = await store.getters["userSession/GET_STATION"];
    this.abolength = await store.getters["reservation/GET_ABO_LENGTH"];
    this.selectedAbo = await store.getters["reservation/GET_SELECTEDABO"];
    this.grouptypes = await store.getters["cargroup/GET_GLOBAL_GROUPTYPES"];
    // console.log(this.abolength);
    store.watch(
      // eslint-disable-next-line
      (state, getters) => getters["general/GET_ORMLOADED"],
      (val) => {
        this.ormload = val;
        this.stations = store.getters["stations/GET_STATIONS"];
        this.station = store.getters["userSession/GET_STATION"];
      }
    );
    store.watch(
      // eslint-disable-next-line
      (state, getters) => getters["cargroup/GET_GLOBAL_CARGROUPS"],
      (val) => {
        this.carGroup = JSON.parse(JSON.stringify(val));
        this.grouptypes = store.getters["cargroup/GET_GLOBAL_GROUPTYPES"];
        /// FILTER CAR CATEGORIES - SHOW ONLY CATEGROIES NOT ALL CARGROUPS
        this.carGroup.forEach((element) => {
          element["vehicle_category"].forEach((vehiclecategory) => {
            if (!this.search(vehiclecategory.id, this.carcategory)) {
              const enabled = element.enabled_stations;
              for (const key in enabled) {
                if (Object.hasOwnProperty.call(enabled, key)) {
                  const newElement = JSON.parse(JSON.stringify(element));
                  newElement["category"] = vehiclecategory.id;
                  this.carcategory.push(newElement);
                  return;
                }
              }
            }
          });
        });
        this.carGroup = this.carcategory;
        this.carGroup.forEach((element) => {
          element["text_web"] = this.stripHTML(element["text_web"]).trim();
        });
        const typeFilter = {};
        this.carcategory.forEach((element) => {
          if (!(element.type in typeFilter)) {
            typeFilter[element.type] = [];
          }
          typeFilter[element.type].push(element);
        });
        // console.log(typeFilter);
        this.carGroup = typeFilter;
      }
    );

    this.carGroup = await store.getters["cargroup/GET_GLOBAL_CARGROUPS"];

    if (this.carGroup.length > 0) {
      /// FILTER CAR CATEGORIES - SHOW ONLY CATEGROIES NOT ALL CARGROUPS
      this.carGroup.forEach((element) => {
        element["vehicle_category"].forEach((vehiclecategory) => {
          if (!this.search(vehiclecategory.id, this.carcategory)) {
            const enabled = element.enabled_stations;
            for (const key in enabled) {
              if (Object.hasOwnProperty.call(enabled, key)) {
                const newElement = JSON.parse(JSON.stringify(element));
                newElement["category"] = vehiclecategory.id;
                this.carcategory.push(newElement);
                return;
              }
            }
          }
        });
      });
      this.carGroup = this.carcategory;
      this.carGroup.forEach((element) => {
        element["text_web"] = this.stripHTML(element["text_web"]).trim();
      });
    }

    this.selectedCarType = await store.getters["userSession/GET_CARTYPE"];
    // if (this.carGroup.length <= 0) {
    //   await store.dispatch("cargroup/SET_CARGROUPS_ALL");
    // }

    // eslint-disable-next-line
    if (this.clientdata["searchbar_background"]) {
      // eslint-disable-next-line
      this.backgroundImage = this.clientdata["searchbar_background"];
    }

    if (document.getElementById("crentCarfilter")) {
      if (
        document.getElementById("crentCarfilter").dataset.image != "" &&
        document.getElementById("crentCarfilter").dataset.image
      ) {
        this.backgroundImage = document.getElementById(
          "crentCarfilter"
        ).dataset.image;
      }
    }

    store.watch(
      // eslint-disable-next-line
      (state, getters) => getters["userSession/GET_STATION"],
      (val) => {
        this.station = store.getters["stations/GET_STATION_BY_ID"](val);
      }
    );
  },
  methods: {
    selectCar(type) {
      this.carSelected = type;
      store.dispatch(
        "userSession/SET_CAR_SELECTED",
        JSON.parse(JSON.stringify(type.category))
      );
    },
    async getCars() {
      const times = await store.getters["stations/GET_OPENINGTIMES"];
      // const carcat = await store.getters["userSession/GET_CARCATEGORY"];
      // const cartype = Object.keys(carcat)[0];
      buildDataLayer("set_dealer");
      buildDataLayer("show_offers");
      if (times) {
        this.loading = true;
        if (process.env.VUE_APP_STANDALONE == "true") {
          this.$router.push({ name: "Reservation_Step1" });
        } else {
          const baseUrl = window.location.origin;
          window.location.href =
            baseUrl +
            process.env.VUE_APP_BASE_URL +
            process.env.VUE_APP_RESERVATION_PATH +
            process.env.VUE_APP_RESERVATION_PATH_STEP1;
        }
      }
    },
    search(nameKey, myArray) {
      for (let i = 0; i < myArray.length; i++) {
        if (myArray[i].category === nameKey) {
          return myArray[i];
        }
      }
    },
    updateFilter(ev) {
      this.selectedGroup = ev.selectedGroup;
      this.selectedAll = ev.selectedAll;
    },
    updateEqFilter() {
      // console.log(ev);
    },
    setCarType(cat) {
      console.log("cat", cat);
      this.selectedCarType = cat;
      // store.dispatch(
      //   "userSession/SET_CAR_SELECTED",
      //   JSON.parse(JSON.stringify(this.selectedCarType))
      // );
    },
    selectAbo(abo) {
      store.dispatch("reservation/SET_ABOLENGTH", abo);
      store.dispatch("stations/SET_OPENINGTIMES");
    },
    getStations() {
      const carcat = store.getters["userSession/GET_CARCATEGORY"];
      const cartype = Object.keys(carcat)[0];
      const time = store.getters["userSession/GET_RESERVATIONDATE_START"];
      const plz = this.plz;

      buildDataLayer("search_dealer", cartype + "|" + time + "|" + plz);

      if (!this.ownercode) {
        store.dispatch("stations/GET_STATION_FROM_PLZ", this.plz).then(() => {
          this.step = 2;
          this.stations = store.getters["stations/GET_STATIONS"];
        });
      } else {
        store
          .dispatch("stations/GET_STATION_WITH_OWNERCODE", this.ownercode)
          .then(() => {
            this.step = 2;
            this.stations = store.getters["stations/GET_STATIONS"];
          });
      }
    },
    getIcon(type) {
      switch (type) {
        case "PKW":
          return "fa-car";
        case "LKW":
          return "fa-truck";
        case "NUTZFAHRZEUGE":
          return "fa-truck";
        case "ELEKTROFAHRZEUGE":
          return "fa-bolt";
        default:
          return "fa-car";
      }
    },
  },
});
</script>
